import { getImageUrl } from 'helpers';
import { useEffect, useRef, useState } from 'react';
import { ReactComponent as Arrow } from 'assets/icons/button/arrow.svg';

const MapListDropdown = ({ selectedCountry, setSelectedCountry, countries }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const contentRef = useRef(null);
    const [height, setHeight] = useState('0px');

    const toggleDropdown = (e) => {
        e.stopPropagation();
        setDropdownOpen(!dropdownOpen);
        setHeight(dropdownOpen ? '0px' : `255px`);
    };

    const handleCountryChange = country => {
        setSelectedCountry(country);
        setDropdownOpen(false);
        setHeight('0px');

        const code = String(country.attributes.country_code).toLowerCase();
        const map = document.querySelector(`.location-map`);
        const svg = map.querySelector(`svg`);
        const parentPos = svg.getBoundingClientRect();
        const childPos = svg.querySelector(`#${code}`).getBoundingClientRect();
        const relativePos = {
            top: childPos.top - parentPos.top,
            right: childPos.right - parentPos.right,
            bottom: childPos.bottom - parentPos.bottom,
            left: childPos.left - parentPos.left,
        };
        const x = parentPos.width / 2 - relativePos.left - 20;
        const y = parentPos.height / 2 - relativePos.top - 20;
        svg.style.transform = `translate(${x}px, ${y}px)`;
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (contentRef.current && !contentRef.current.contains(e.target)) {
                setDropdownOpen(false);
                setDropdownOpen(false);
                setHeight('0px');
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [contentRef]);

    return (
        <div className={`location-map-dropdown ${dropdownOpen ? 'open' : 'closed'}`} onClick={toggleDropdown}>
            <div className="body3 location-map-dropdown-name">Country*</div>
            <div className={` location-map-select ${dropdownOpen ? 'open' : 'closed'}`}>
                {selectedCountry ? (
                    <div className=" location-map-select-country">
                        <img
                            className="location-map-select-country-flag"
                            src={getImageUrl(selectedCountry.attributes.flag)}
                            alt={selectedCountry.attributes.name}
                        />
                        <span>{selectedCountry.attributes.name}</span>
                    </div>
                ) : (
                    'Select a country'
                )}{' '}
                <Arrow className="arrow" />
            </div>
            <div
                ref={contentRef}
                style={{ maxHeight: `${height}` }}
                className={` location-map-options ${dropdownOpen ? 'open' : 'closed'}`}
            >
                {countries?.map((country, index) => (
                    <div key={index} className="location-map-options-item" onClick={() => handleCountryChange(country)}>
                        <img
                            className="location-map-options-item-flag"
                            src={getImageUrl(country.attributes.flag)}
                            alt={country.attributes.name}
                        />
                        <span className="body2">{country.attributes.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MapListDropdown;
